module.exports = __webpack_public_path__ + "img/bilibili_link.67fd6954.png";